import { render, staticRenderFns } from "./SurveyQuestionTypeField.vue?vue&type=template&id=60da723a"
import script from "./SurveyQuestionTypeField.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports